// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@rugby/App/Services/EmailService";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;

export const XngPopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        topic: state.fieldValues["topic"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        account: state.fieldValues["account"],
        companyName: state.fieldValues["companyName"],
        salesRepName: state.fieldValues["salesRepName"],
        emailAddress: state.fieldValues["emailAddress"],
        phoneNumber: state.fieldValues["phoneNumber"],
        address: state.fieldValues["address"],
        comments: state.fieldValues["comments"],
        message: state.fieldValues["message"],
        city: state.fieldValues["city"],
        zipCode: state.fieldValues["zipCode"],
        state: state.fieldValues["state"],
        province: state.fieldValues["province"],
        postalCode: state.fieldValues["postalCode"],
        emailTo: props.parameter.emailRecipients,
    };
};

export const XngSendDataToApi: HandlerType = async props => {
    await submitContactUsForm(props.apiParameter);
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, SendDataToApi, XngSendDataToApi);
